import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { SectionHeading } from "./Services";
import { Users, Wrench, Package } from "lucide-react";

const ICONS = [Users, Wrench, Package];

export default function Aseo() {
  const { t } = useLang();
  const a = t.aseo;
  const ref = useReveal();

  return (
    <section id="aseo" className="bg-[#f4f6f9] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div ref={ref} className="reveal">
            <SectionHeading eyebrow={a.eyebrow} title={a.title} subtitle={a.subtitle} />
            <div className="mt-10 space-y-6">
              {a.items.map((item, i) => {
                const Icon = ICONS[i];
                return (
                  <div key={i} className="flex gap-4">
                    <span className="shrink-0 flex items-center justify-center w-12 h-12 rounded-xl bg-[#f5871f]/12 border border-[#f5871f]/25">
                      <Icon className="w-6 h-6 text-[#f5871f]" />
                    </span>
                    <div>
                      <h3 className="font-display font-700 text-lg uppercase text-[#0d2140]">{item.title}</h3>
                      <p className="text-[#0d2140]/60 text-sm mt-1 leading-relaxed">{item.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img src={a.img} alt={a.title} className="w-full h-[460px] object-cover" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#0d2140] text-white rounded-2xl px-6 py-5 shadow-xl hidden md:block">
              <div className="font-display font-700 text-3xl text-[#f5871f]">100%</div>
              <div className="text-xs uppercase tracking-widest text-white/70 font-display mt-1">
                Todo incluido
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
